import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=b6a2eb10&scoped=true&"
import script from "./PersonalProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalProfile.vue?vue&type=script&lang=js&"
import style0 from "./PersonalProfile.vue?vue&type=style&index=0&id=b6a2eb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a2eb10",
  null
  
)

export default component.exports